const xpath = require('./build/Release/xpathWrapper.node');
//console.log(xpath);
module.exports = xpath;